import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RelevanceStatus } from '../../../models/relevance-status';
import { getRelevanceStatusColor } from '../../../core/ui/theme/relevance-status-colors';

@Component({
  selector: 'app-relevance-status-chip',
  templateUrl: './relevance-status-chip.component.html',
  styleUrls: ['./relevance-status-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelevanceStatusChipComponent {

  readonly getColor =  getRelevanceStatusColor;

  @Input() status: RelevanceStatus;

}
